// extracted by mini-css-extract-plugin
export default {"tvPage":"TVPage_tvPage__hWEoG"};